function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import ButtonTag from "segments/desktop/core-components/button-tag/button-tag";
import { StyledButtonTagsGridComponent } from "./button-tags-grid-component.scss";
class ButtonTagsGridComponent extends PureComponent {
    renderButtonTags() {
        const { gridButtonTags, isOpenLinkInNewTab } = this.props;
        return gridButtonTags.map((buttonTag, index)=>{
            return /*#__PURE__*/ _jsx("li", {
                className: "grid-button-container",
                children: /*#__PURE__*/ _jsx(ButtonTag, _object_spread_props(_object_spread({}, buttonTag), {
                    isOpenLinkInNewTab: isOpenLinkInNewTab
                }))
            }, index);
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(StyledButtonTagsGridComponent, {
            className: "button-tags-grid-component",
            children: /*#__PURE__*/ _jsx("ul", {
                className: "grid-button-list",
                children: this.renderButtonTags()
            })
        });
    }
}
export { ButtonTagsGridComponent as default };
ButtonTagsGridComponent.defaultProps = {
    isOpenLinkInNewTab: true,
    gridButtonTags: [
        {
            tagImg: {
                src: "/static/img/button/pm.png"
            },
            tagText: "Project Management"
        },
        {
            tagImg: {
                src: "/static/img/button/software_dev.png"
            },
            tagText: "Software Developement"
        },
        {
            tagImg: {
                src: "/static/img/button/cs.png"
            },
            tagText: "Customer Support"
        },
        {
            tagImg: {
                src: "/static/img/button/hr.png"
            },
            tagText: "HR"
        },
        {
            tagImg: {
                src: "/static/img/button/m.png"
            },
            tagText: "Marketing"
        },
        {
            tagImg: {
                src: "/static/img/button/mediaproduction.png"
            },
            tagText: "Media and Production"
        },
        {
            tagImg: {
                src: "/static/img/button/opsit.png"
            },
            tagText: "Operations/IT"
        },
        {
            tagImg: {
                src: "/static/img/button/sales.png"
            },
            tagText: "Sales"
        }
    ]
};
